import { Symbols } from '@ioc/symbols'
import { inject, injectable } from 'inversify'

import { FetchClient } from '@writefull/core'

import { SessionStore } from '@infrastructure/stores/session/session-store'

@injectable()
export default class CustomerPortalBackendApi {
  constructor(
    @inject(Symbols.ENVIRONMENT) private readonly environment: ImportMetaEnv,
    @inject(FetchClient) private readonly fetchClient: FetchClient,
    @inject(SessionStore) private readonly sessionStore: SessionStore,
  ) {}

  public synchronizeOverleafStatus(): Promise<any> {
    return this.post<any, any>(
      `${this.environment.VITE_WF_CUSTOMER_PORTAL_URL}/api/user/status/synchronize`,
      {},
    )
  }

  private post<P, T>(url: string, payload: P): Promise<T> {
    const session = this.sessionStore.getState().session
    if (!session?.idToken) {
      throw new Error('No current session.')
    }
    return this.fetchClient.post<T>(url, payload, undefined, {
      headers: session?.idToken ? { token: session.idToken } : {},
    })
  }
}
